import type { GuestInvitationCreateResult, GuestInvitationDto, RecentGuest } from '@hub-wifi/shared'
import { apiRequest } from './client'

export interface CreateGuestInvitationBody {
  guestName: string
  guestEmail?: string | null
  guestPhone?: string | null
  visitDate: string
  visitTimeBegin: string
  visitTimeEnd: string
  singleAccess?: boolean
  /** Language of the guest email (and its calendar links). */
  language?: 'pt-BR' | 'en'
  /**
   * Optional link to a coworker's room booking. When supplied, the server
   * copies `buildingId` / `visitDate` / `visitTimeBegin` / `visitTimeEnd`
   * from the booking and ignores the client-supplied values for those fields.
   */
  roomBookingId?: string
}

export function listGuestInvitations(token: string): Promise<GuestInvitationDto[]> {
  return apiRequest<GuestInvitationDto[]>('/api/guest-invitations', { token })
}

export function listRecentGuests(token: string): Promise<RecentGuest[]> {
  return apiRequest<RecentGuest[]>('/api/guest-invitations/recent-guests', { token })
}

export function createGuestInvitation(
  body: CreateGuestInvitationBody,
  token: string,
): Promise<GuestInvitationCreateResult> {
  return apiRequest<GuestInvitationCreateResult>('/api/guest-invitations', {
    method: 'POST',
    body,
    token,
  })
}
